import { reduce } from 'lodash';
import { validateFormInput } from './validateFormInput';
import { TMutationContext } from '../../../../hooks/useContexts/types';
import { TInputState } from '../types';

export const validateFormInputs = (
  inputs: Record<string, TInputState>,
  context: Partial<TMutationContext>
): Record<string, TInputState> => {
  return reduce(
    inputs,
    (r, v, k) => ({
      ...r,
      [k]: validateFormInput(v, context),
    }),
    {}
  );
};
